<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Dialog para Agregar Tarjeta -->
    <v-dialog
      max-width="65%"
      v-model="dialogAdd"
      persistent
    >
      <v-card>
        <v-card-title>
          Agregar Tarjeta para Devoluciones
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.id_banco"
                :items="bancos"
                item-text="nombre"
                item-value="id_banco"
                label="Banco"
                outlined
                dense
                hide-details
                :loading="loadingBancos"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.tipo_tarjeta"
                :items="tiposTarjeta"
                label="Tipo de Tarjeta"
                outlined
                dense
                hide-details
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.numero_tarjeta"
                label="Número de Tarjeta (16 dígitos)"
                outlined
                dense
                hide-details
                maxlength="16"
                counter
                @input="onlyNumbers"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAdd">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAdd" :loading="loadingSave">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para Eliminar Tarjeta -->
    <v-dialog
      max-width="65%"
      v-model="dialogDelete"
      persistent
    >
      <v-card>
        <v-card-title>
          Eliminar Tarjeta
        </v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar la tarjeta {{ selectedItem.tipo_tarjeta }} del banco "{{ selectedItem.nombre_banco }}" terminada en {{ selectedItem.numero_tarjeta.slice(-4) }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón para agregar -->
    <v-row>
      <v-col cols="12">
        <v-btn
          color="primary"
          @click="openDialogAdd"
        >
          Agregar Tarjeta
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla de tarjetas -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.numero_tarjeta`]="{ item }">
            **** **** **** {{ item.numero_tarjeta.slice(-4) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="openDialogDelete(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    // ========== CONFIGURACIÓN DE MODO ==========
    useMockData: true, // Cambiar a false para usar API real
    // ===========================================
    
    dialogAdd: false,
    dialogDelete: false,
    loading: false,
    loadingBancos: false,
    loadingSave: false,
    loadingDelete: false,
    items: [],
    bancos: [],
    tiposTarjeta: ['Crédito', 'Débito'],
    editedItem: {
      id_banco: null,
      tipo_tarjeta: null,
      numero_tarjeta: ""
    },
    defaultEditedItem: {
      id_banco: null,
      tipo_tarjeta: null,
      numero_tarjeta: ""
    },
    selectedItem: {
      id_tarjeta_empleado: null,
      id_banco: null,
      nombre_banco: "",
      tipo_tarjeta: "",
      numero_tarjeta: ""
    },
    headers: [
      {
        text: "Banco",
        value: "nombre_banco",
        align: "center",
        width: "30%"
      },
      {
        text: "Tipo",
        value: "tipo_tarjeta",
        align: "center",
        width: "20%"
      },
      {
        text: "Número de Tarjeta",
        value: "numero_tarjeta",
        align: "center",
        width: "40%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],
    // ========== DATOS MOCK ==========
    mockTarjetas: [
      {
        id_tarjeta_empleado: 1,
        id_banco: "6f71c6a2-18cb-4502-b945-8b9fa794b4bc",
        nombre_banco: "BBVA MEXICO",
        tipo_tarjeta: "Débito",
        numero_tarjeta: "4152313812345678"
      },
      {
        id_tarjeta_empleado: 2,
        id_banco: "f0ec3afa-ad4b-4918-9bab-b6814a6f4bba",
        nombre_banco: "HSBC",
        tipo_tarjeta: "Crédito",
        numero_tarjeta: "5425233430109903"
      }
    ],
    mockNextId: 3
    // ===============================
  }),
  mounted() {
    this.getItems();
    this.getBancos();
  },
  methods: {
    // ========== MÉTODOS PRINCIPALES ==========
    getItems() {
      if (this.useMockData) {
        this.getItemsMock();
      } else {
        this.getItemsAPI();
      }
    },
    saveAdd(data) {
      if (this.useMockData) {
        return this.saveAddMock(data);
      } else {
        return this.saveAddAPI(data);
      }
    },
    deleteItem(id) {
      if (this.useMockData) {
        return this.deleteItemMock(id);
      } else {
        return this.deleteItemAPI(id);
      }
    },

    // ========== MÉTODOS MOCK ==========
    getItemsMock() {
      this.loading = true;
      setTimeout(() => {
        this.items = [...this.mockTarjetas];
        this.loading = false;
      }, 500);
    },
    saveAddMock(data) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // Verificar si ya existe la misma tarjeta
          const existe = this.mockTarjetas.some(
            item => item.numero_tarjeta === data.numero_tarjeta
          );
          if (existe) {
            reject({ response: { status: 409 } });
            return;
          }

          // Buscar el nombre del banco
          const banco = this.bancos.find(b => b.id_banco === data.id_banco);
          
          // Agregar nuevo item
          const nuevoItem = {
            id_tarjeta_empleado: this.mockNextId++,
            id_banco: data.id_banco,
            nombre_banco: banco.nombre,
            tipo_tarjeta: data.tipo_tarjeta,
            numero_tarjeta: data.numero_tarjeta
          };
          this.mockTarjetas.push(nuevoItem);
          resolve();
        }, 500);
      });
    },
    deleteItemMock(id) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const index = this.mockTarjetas.findIndex(
            item => item.id_tarjeta_empleado === id
          );
          if (index !== -1) {
            this.mockTarjetas.splice(index, 1);
          }
          resolve();
        }, 500);
      });
    },

    // ========== MÉTODOS API ==========
    getItemsAPI() {
      this.loading = true;
      axios
        .get('/RecursosHumanos/ListarTarjetasEmpleado')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    getBancos() {
      this.loadingBancos = true;
      axios
        .get('/Catalogos/ListarBancos')
        .then(response => {
          this.bancos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingBancos = false;
        })
    },
    saveAddAPI(data) {
      return axios.post('/RecursosHumanos/AgregarTarjetaEmpleado', data);
    },
    deleteItemAPI(id) {
      return axios.delete(`/RecursosHumanos/EliminarTarjetaEmpleado/${id}`);
    },

    // ========== MÉTODOS DE UI ==========
    openDialogAdd() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAdd = true;
    },
    closeDialogAdd() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAdd = false;
    },
    onlyNumbers() {
      // Eliminar cualquier carácter que no sea número
      this.editedItem.numero_tarjeta = this.editedItem.numero_tarjeta.replace(/\D/g, '');
    },
    saveDialogAdd() {
      // Validar banco
      if (this.editedItem.id_banco == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar un banco");
        this.$refs.alert.open();
        return;
      }

      // Validar tipo de tarjeta
      if (this.editedItem.tipo_tarjeta == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar el tipo de tarjeta");
        this.$refs.alert.open();
        return;
      }

      // Validar número de tarjeta
      if (this.editedItem.numero_tarjeta == null || this.editedItem.numero_tarjeta.length !== 16) {
        this.$refs.alert.setMessage("", "El número de tarjeta debe tener exactamente 16 dígitos");
        this.$refs.alert.open();
        return;
      }

      // Validar que solo contenga números
      if (!/^\d+$/.test(this.editedItem.numero_tarjeta)) {
        this.$refs.alert.setMessage("", "El número de tarjeta solo debe contener números");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      const data = {
        id_banco: this.editedItem.id_banco,
        tipo_tarjeta: this.editedItem.tipo_tarjeta,
        numero_tarjeta: this.editedItem.numero_tarjeta
      };

      this.saveAdd(data)
        .then(() => {
          this.getItems();
          this.closeDialogAdd();
        })
        .catch(error => {
          if (error.response && error.response.status == 409) {
            this.$refs.alert.setMessage("", "Esta tarjeta ya está registrada.");
            this.$refs.alert.open();
          } else {
            this.$refs.alert.setMessage("", "Error al agregar la tarjeta.");
            this.$refs.alert.open();
          }
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    openDialogDelete(item) {
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.selectedItem = {
        id_tarjeta_empleado: null,
        id_banco: null,
        nombre_banco: "",
        tipo_tarjeta: "",
        numero_tarjeta: ""
      };
      this.dialogDelete = false;
    },
    saveDialogDelete() {
      this.loadingDelete = true;
      
      this.deleteItem(this.selectedItem.id_tarjeta_empleado)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(error => {
          console.log(error);
          this.$refs.alert.setMessage("", "Error al eliminar la tarjeta.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
}
</script>